<template>
  <el-dialog
    title="添加红包券信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="title"
        label="标题"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item
              prop="start_time"
              label="开始日期"
              :rules="[{ required: true, message: '不能为空'}]"
      >

        <el-date-picker
                v-model="form.start_time"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>

      </el-form-item>

      <el-form-item
              prop="end_time"
              label="结束日期"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-date-picker
                v-model="form.end_time"
                type="date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        prop="total_num"
        label="库存"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.total_num"></el-input>
      </el-form-item>
      <el-form-item
              prop="least_cost"
              label="支付金额"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.least_cost"></el-input>
      </el-form-item>
      <el-form-item
        prop="reduce_cost"
        label="红包券"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.reduce_cost"></el-input>
      </el-form-item>
      <el-form-item
              prop="member_cost"
              label="会员价格"
      >
        <el-input v-model="form.member_cost"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "smallposterEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,

      form: {
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.title = this.oneclass.title;
          form.start_time = this.oneclass.start_time;
          form.end_time = this.oneclass.end_time;
          form.total_num = this.oneclass.total_num;
          form.least_cost = this.oneclass.least_cost;
          form.reduce_cost = this.oneclass.reduce_cost;
          form.member_cost = this.oneclass.member_cost;

          this.form = form;
       // });
          this.formEdit = true;
      } else {
          this.formEdit = true;
          this.fileList =[];
        this.form = {};
      }
    },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                        this.loading = true;
            agentService.saveEncourage({ ...this.form,agentid:util.cookies.get('agentid'), xt_id:util.cookies.get('xt_id'),id:this.oneclass.id})
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

